<template>
  <div class="container-login">
    <v-form>
      <v-container fluid style="width: 100% !important; max-width: 100% !important">
        <v-row justify="center">
          <v-col cols="4">
            <v-row>
              <!-- <v-col cols="12"><div style="height: 40px;"></div></v-col> -->
              <v-col cols="12" class="text-center text-4xl font-semibold">
                <font class="textcolor1--text">SmartLink </font><font class="light-blue--text textcolor2--text">Platform</font>
              </v-col>
              <v-col cols="12"><div style="height: 30px;"></div></v-col>
              <v-col cols="12" class="text-center text-3xl font-semibold textcolor1--text blue--text">
                Forgot your password?
              </v-col>
              <v-col cols="12" class="text-center textcolor2--text">
                Don't worry. We'll help you.
              </v-col>
              <v-col cols="12" class="text-sm">
                Submit your email address and we'll send you a link to reset your password.
              </v-col>
              <v-col cols="12">
                <v-text-field
                  ref="usr_id"
                  v-model="userid"
                  placeholder="Email Address"
                  append-icon="fa fa-envelope-open"
                  hide-details
                  dense
                  solo
                  height="40"
                  class="login-field"
                ></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-btn
                  block
                  x-large
                  color="primary"
                  @click="submit()"
                >
                Submit<v-icon class="ml-3" small>fa fa-arrow-right</v-icon></v-btn>
              </v-col>
              <v-col cols="12" class="text-center text-xs textcolor3--text">
                Heads up! You may need to check your spam folder or unblock SmartLink Platform@cyberlogitec.com
              </v-col>
              <v-col cols="12" class="text-right">
                <a @click="$router.push('/login');" class="underline">Return to Sign in</a>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-container>
    </v-form>
    <dialogWindow
      ref="ForgotPasswordDialog"
      :info="checkDialogTitle"
      size="max"
      :color="checkDialogColor"
    >
    </dialogWindow>
  </div>
</template>

<script>
import dialogWindow from '@/vue-dlb/components/NewDialog.vue';
  export default {
    components: {
      dialogWindow,
    },
    data: () => ({
      userid: '',
      userpwd: '',
      checkDialogColor: 'success',
      checkDialogTitle: '',
    }),

    mounted() {
      setTimeout(()=> {
        this.$refs.usr_id.focus();
      }, 300);
    },

    methods: {
      submit() {
        const param = {usrId: this.userid}
        this.$store.dispatch('forgotPassword', param).then((res) => {
          if (res.status === 0) {
            this.checkDialogColor = 'warning';
            this.checkDialogTitle = res.message;
          } else {
            this.checkDialogColor = 'success';
            this.checkDialogTitle = res.message;
          }
          this.$refs.ForgotPasswordDialog.dialog = true;
          console.log("forgotPassword ok", res)
        }).catch((err) => {
          console.log("forgotPassword", err)
        });
      },
    }
  }
</script>